import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url, joinApiPath } from '../apiConfig';

export function useFetchLaststores(url, dependencies = []) {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        getApiData(url);
    }, [url, ...dependencies]);

    const getApiData = async (url) => {
        setIsLoading(true);
        try {
            const fullUrl =
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`.replace(
              /([^:]\/)\/+/g,
              "$1"
            );
             const token = localStorage.getItem("authToken");

            const response = await axios.get(joinApiPath(fullUrl, url),{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                },
            });
            setData(response.data);
        } catch (error) {
            console.log('An error occurred while fetching the API:', error);
            setError(error.response?.statusText || error.message);
        } finally {
            setIsLoading(false);
        }
    };
    return { data, setData, isLoading, error };
}